import styled from 'styled-components';

const HeroSectionStyle = styled.div`
    .platform-hero-section {
        position: relative;
        width: 100%;
        margin-bottom: 100px;
    }

    .platform-hero-section:before {
        content: '';
        display: block;
        width: 100%;
        padding-top: 56.25%;
    }

    .platform-hero-section video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .platform-hero-points {
        position: absolute;
        left: 20px;
        top: 150px;
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        z-index: 1;
    }

    .platform-hero-points button {
        width: 60px;
        height: 60px;
        border-radius: 8px;
        background-color: #ffffff;
        font-size: 20px;
        text-transform: uppercase;
        font-weight: 700;
        cursor: pointer;
        transition: background-color 240ms, color 240ms;
    }

    .platform-hero-points button:empty {
        display: none;
    }

    .platform-hero-points button:hover {
        background-color: #ff7567;
        color: #ffffff;
    }

    .platform-hero-points button.active {
        background-color: #E45F53;
        color: #ffffff;
        pointer-events: none;
    }

    .platform-hero-points .coming-soon-wrapper {
        position: relative;
        display: flex;
    }

    .platform-hero-points .coming-soon-wrapper button[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    .platform-hero-points .coming-soon-tooltip {
        position: absolute;
        left: calc(100% + 10px);
        top: 50%;
        transform: translateY(-50%);
        background-color: rgba(0, 0, 0, 0.75);
        color: #ffffff;
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
        padding: 5px 10px;
        border-radius: 4px;
        pointer-events: none;
        opacity: 0;
        transition: opacity 200ms;
    }

    .platform-hero-points .coming-soon-wrapper:hover .coming-soon-tooltip {
        opacity: 1;
    }

    @media screen and (max-width: 1023px) {
        .platform-hero-section {
            margin-bottom: 30px;
        }

        .platform-hero-section:before {
            padding-top: 177.77777777777777%;
        }
        
        .platform-hero-points {
            top: 106px;
            left: 8px;
        }

        .platform-hero-points button {
            width: 50px;
            height: 50px;
        }
    }
`;

export default HeroSectionStyle;
